import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import ShowHideColumns from '../showHideColumns'

const ShowHideColumnsModal = ({ display, toggle, columns, shownColumns, setShownColumns, storageName }) => {
    const { t } = useTranslation()

    return (
        <Modal
            show={display}
            onHide={() => toggle(false)}
            size="lg"
            centered
            className="showhide-columns-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ width: '98%' }}>
                    <div className="sb-modal-head">
                        <span className="sb-modal-ic">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="12" y1="3" x2="12" y2="21"/></svg>
                        </span>
                        <div className="sb-modal-htext">
                            <span className="sb-modal-eyebrow">{t('common.view')}</span>
                            <span className="sb-modal-title">{t('columns.showHideColumns')}</span>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <h4 className="text-center mb-4">Show/Hide Columns</h4> */}

                <ShowHideColumns columns={columns} shownColumns={shownColumns} setShownColumns={setShownColumns} toggle={toggle}
                    storageName={storageName} />

            </Modal.Body>


        </Modal>
    )
}

export default ShowHideColumnsModal

